import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconEvent.tsx
const OutlinedFilledEvent = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z" })
});
const OutlinedEvent = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-60h82v60h306v-60h82v60h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z" })
});
const RoundedFilledEvent = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Z" })
});
const RoundedEvent = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM189-55q-39.05 0-66.53-27.47Q95-109.95 95-149v-602q0-39.46 27.47-67.23Q149.95-846 189-846h56v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.83 0 28.82 12.12Q327-881.75 327-865v19h306v-19q0-16.75 12.39-28.88 12.4-12.12 28.8-12.12 16.84 0 28.82 12.12Q715-881.75 715-865v19h56q39.46 0 67.23 27.77Q866-790.46 866-751v602q0 39.05-27.77 66.53Q810.46-55 771-55H189Zm0-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z" })
});
const SharpFilledEvent = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Z" })
});
const SharpEvent = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M596.82-220Q556-220 528-248.18q-28-28.19-28-69Q500-358 528.18-386q28.19-28 69-28Q638-414 666-385.82q28 28.19 28 69Q694-276 665.82-248q-28.19 28-69 28ZM95-55v-791h150.2v-60H327v60h306v-60h82.2v60H866v791H95Zm94-94h582v-421H189v421Zm0-481h582v-121H189v121Zm0 0v-121 121Z" })
});
const componentMap = {
	outlined: OutlinedEvent,
	"outlined-fill": OutlinedFilledEvent,
	rounded: RoundedEvent,
	"rounded-fill": RoundedFilledEvent,
	sharp: SharpEvent,
	"sharp-fill": SharpFilledEvent
};
const IconEvent = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconEvent };